interface RouteConstantInterface {
  addEditAddress: string;
  addAddress1: string;
  addAddress: string;
  userAddresses: string;
  addEditAddressArea: string;
  addEditAddressAreaid: string;
  forgotPassword: string;
  userPassword: string;
  resetPassword: string;
  register: string;
  login: string;
  products: string;
  profile: string;
  orderSummary: string;
  userOrders: string;
  wishList: string;
  basket: string;
  productDetail: string;
  payment: string;
  measurement: string;
  courierCharges: string;
  courierProvider: string;
  userPreferredDelivery: string;
  banner: string;
  setting: string;
  openorders: string;
  aboutUs: string;
  privacyPolicy: string;
  contactUs: string;
  termsAndConditions: string;
  registerTermsAndConditions: string;
  returnPolicy: string;
  shippingPolicy: string;
  orderList: string;
  invoice: string;
  billingOrderDetails: string;
  billingOrderReceipt: string;
  assignroutecode: string;
  courierProviderList: string;
  myOrders: string;
  generateInvoice: string;
  getwayProcess: string;
  paymentResponse: string;
  editUsers: string;
  customerAddress: string;
  viewAllProducts: string;
  viewAllRouteCodes: string;
  viewCountry: string;
  ViewAllStates: string;
  ViewAllCity: string;
  ViewAllCategory: string;
  ViewAllSubCategory: string;
  editaddresss: string;
  editaddresssId: string;
  newinvoice: string;
  addArea: string;
  NewCountry: string;
  addState: string;
  addDistrict: string;
  newAreaPincode: string;
  ViewAllComplaints: string;
  ViewAllStatus: string;
  //complaintRegister: string;
  viewAllCategories: string;
  ComplaintType: string;
  addSubdistrict: string;
  canceledOrders: string;
  packingOrders: string;
  binOrders: string;
  customerReports: string;
  customerFollowUpReport: string;
  deliveryDetails: string;
  cashDeposite: string;
  GenerateProductCode: string;
  AddNewVendor: string;
  AllVendors: string;
  productSummary: string;
  deliveryAddress: string;
  positems: string;
  posmovements: string;
  gstSalesReports: string;
  AssignExecutive: string;
  Geomap: string;
  Geomapsearch: string;
  newGenerateInvoice: string;
  InternalComplaints: string;
  ComplaintRegisters: string;
  ComplaintMain: string;
  ComplaintActionMain: string;
  oilProduction: string;
  oilProduction1: string;
  desiriUsers: string;
  desiriBulls: string;
  desiriGaana: string;
  desiriRoles: string;
  RoleAssignment: string;
  CreatingRole: string;
  oilProductiondatatable: string;
  oilProductiondatatable1: string;
  RawMaterialsPurchase: string;
  RawMaterialsPurchasedatatable: string;
  CustomerComplaintMain: string;
  CustomerServComplaintRegister: string;
  posTargetMapping: string;
  posReportDetails: string;
  FeatureAccessAssign: string;
  mySubscriptions: string;
  posInventoryReport: string;
  DeliveryCashMain: string;
  TestReports: string;
  storeCashMain: string;
  TestReporttest: string;
  deliveryAnalysis: string;
  ViewRawMaterials: string;
  CustomerExecutiveSalesReport: string;
  InvoicedBySalesReport: string;
  OrderDeliverySummary: string;
  oilProductiondatatable2: string;
  InternalComplaintRegister: string;
  InternalComplaintMain: string;
  InternalComplaintActionMain: string;
  RawMaterialCategories: string;
  OilProductionSummaryReport: string;
  CashReportMain: string;
  CustomerExecutiveTargetMapping: string;
  AccountsCashMain: string;
  outwardChallan: string;
  PerformanceReportforCE: string;
  CEDailyActivityReportModule: string;
  rawmaterialInventory: string;
  rawmaterialMovementLog: string;
  ViewAllChallan: string;
  DeliveryExecutivePerformance: string;
  RawMaterailsReport: string;
  RawMaterialHistory: string;
  AddVehicle: string;
  ProductBatchSummary: string;
  posPProductStockSummary: string;
  BullStatistics: string;
  Traceability: string;
  allUserAddress: string;
  newsManagement: string;
  addNews: string;
  RawMaterialOutwardChallan: string;
  newcomplaintsummary: string;
  mycomplaints: string;
  CustomerserviceComplaintRegister: string;
  UserSwipeMachineAccess: string;
  courierDetails: string;
  myRewards: string;
  productRewardRates: string;
  customerAnalytics: string;
  WipProductionMain: string;
  StockSummaryDashboard: string;
  whyNotDeliveredSummary: string;
  salesProductionReport: string;
  OrderInvoiceTimelineReport: string;
  UserSalesOrdering: string;
  userTrafficAudit: string;

}

const RouteConstant: RouteConstantInterface = {
  addEditAddress: process.env.PUBLIC_URL + "/add-edit-address/:id",
  addAddress: process.env.PUBLIC_URL + "/add-edit-address/",
  addEditAddressArea: process.env.PUBLIC_URL + "/editonarea/",
  addEditAddressAreaid: process.env.PUBLIC_URL + "/editonarea/:id",
  addAddress1: process.env.PUBLIC_URL + "/address/",
  userAddresses: process.env.PUBLIC_URL + "/user-addresses",
  forgotPassword: process.env.PUBLIC_URL + "/forgot-password",
  userPassword: process.env.PUBLIC_URL + "/user-password",
  resetPassword: process.env.PUBLIC_URL + "/reset-password/:mobileNumber",
  register: process.env.PUBLIC_URL + "/register",
  login: process.env.PUBLIC_URL + "/login",
  products: process.env.PUBLIC_URL + "/",
  profile: process.env.PUBLIC_URL + "/user-profile",
  orderSummary: process.env.PUBLIC_URL + "/order-summary",
  orderList: process.env.PUBLIC_URL + "/order-list",
  invoice: process.env.PUBLIC_URL + "/invoices",
  billingOrderDetails: process.env.PUBLIC_URL + "/billing/orderdetails/:invoicenumber",
  billingOrderReceipt: process.env.PUBLIC_URL + "/billing/orderdetails/order-:orderno",
  userOrders: process.env.PUBLIC_URL + "/orders",
  wishList: process.env.PUBLIC_URL + "/my-wish-list",
  basket: process.env.PUBLIC_URL + "/shop/basket",
  productDetail: process.env.PUBLIC_URL + "/product-detail",
  payment: process.env.PUBLIC_URL + "/payment",
  measurement: process.env.PUBLIC_URL + "/measurement",
  courierCharges: process.env.PUBLIC_URL + "/courier-charges",
  courierProvider: process.env.PUBLIC_URL + "/courier-provider",
  userPreferredDelivery: process.env.PUBLIC_URL + "/user-delivery",
  banner: process.env.PUBLIC_URL + "/banner",
  setting: process.env.PUBLIC_URL + "/setting",
  openorders: process.env.PUBLIC_URL + "/open-order",
  aboutUs: process.env.PUBLIC_URL + "/about-us",
  privacyPolicy: process.env.PUBLIC_URL + "/privacy",
  shippingPolicy: process.env.PUBLIC_URL + "/shipping",
  contactUs: process.env.PUBLIC_URL + "/contact-us",
  termsAndConditions: process.env.PUBLIC_URL + "/terms-conditions",
  registerTermsAndConditions: process.env.PUBLIC_URL + "/register-terms-conditions",
  returnPolicy: process.env.PUBLIC_URL + "/return-policy",
  assignroutecode: process.env.PUBLIC_URL + "/assign-route-code",
  courierProviderList: process.env.PUBLIC_URL + "/courier-provider-list",
  myOrders: process.env.PUBLIC_URL + "/my-orders",
  generateInvoice: process.env.PUBLIC_URL + "/generate-inv",
  getwayProcess: process.env.PUBLIC_URL + "/getway-process",
  paymentResponse: process.env.PUBLIC_URL + "/payment-response",
  editUsers: process.env.PUBLIC_URL + "/edit-users",
  customerAddress: process.env.PUBLIC_URL + "/edit-address",
  viewAllProducts: process.env.PUBLIC_URL + "/view-all-products",
  viewAllRouteCodes: process.env.PUBLIC_URL + "/view-all-route-codes",
  viewCountry: process.env.PUBLIC_URL + "/view-country",
  ViewAllStates: process.env.PUBLIC_URL + "/view-state",
  ViewAllCity: process.env.PUBLIC_URL + "/view-city",
  ViewAllCategory: process.env.PUBLIC_URL + "/view-category",
  ViewAllSubCategory: process.env.PUBLIC_URL + "/view-Subcategory",
  editaddresss: process.env.PUBLIC_URL + "/addresss/",
  editaddresssId: process.env.PUBLIC_URL + "/addresss/:id",
  newinvoice: process.env.PUBLIC_URL + "/new-order-list",
  addArea: process.env.PUBLIC_URL + "/addArea",
  NewCountry: process.env.PUBLIC_URL + "/NewCountry",
  addState: process.env.PUBLIC_URL + "/addState",
  addDistrict: process.env.PUBLIC_URL + "/addDistrict",
  newAreaPincode: process.env.PUBLIC_URL + "/area&Pincode",
  ViewAllComplaints: process.env.PUBLIC_URL + "/View-all-Complaints",
  ViewAllStatus: process.env.PUBLIC_URL + "/view-status",
  //complaintRegister: process.env.PUBLIC_URL + "/view-Complaint",
  viewAllCategories: process.env.PUBLIC_URL + "/view-all-categories",
  ComplaintType: process.env.PUBLIC_URL + "/view-complaint-type",
  addSubdistrict: process.env.PUBLIC_URL + "/addSubdistrict",
  canceledOrders: process.env.PUBLIC_URL + "/canceledOrders",
  packingOrders: process.env.PUBLIC_URL + "/Packing-Orders",
  binOrders: process.env.PUBLIC_URL + "/Bin-Orders",
  cashDeposite: process.env.PUBLIC_URL + "/cash_deposite",
  customerReports: process.env.PUBLIC_URL + "/customerReports",
  deliveryDetails: process.env.PUBLIC_URL + "/Delivery-Report",
  GenerateProductCode: process.env.PUBLIC_URL + "/Generate-Product-code",
  AddNewVendor: process.env.PUBLIC_URL + "/Add-New-Vendor",
  AllVendors: process.env.PUBLIC_URL + "/all-vendors",
  customerFollowUpReport: process.env.PUBLIC_URL + "/customerFollowUpReport",
  productSummary: process.env.PUBLIC_URL + "/Product-Summary",
  deliveryAddress: process.env.PUBLIC_URL + "/Delivery-Address",
  positems: process.env.PUBLIC_URL + "/pos-items",
  posmovements: process.env.PUBLIC_URL + "/pos-movements",
  Geomap: process.env.PUBLIC_URL + "/GoogleMapPage",
  Geomapsearch: process.env.PUBLIC_URL + "/OrderSearchById",
  AssignExecutive: process.env.PUBLIC_URL + "/Assign_Executive",
  gstSalesReports: process.env.PUBLIC_URL + "/GST-Sales-Reports",
  RawMaterialsPurchase: process.env.PUBLIC_URL + "/RawMaterialsPurchase",
  newGenerateInvoice: process.env.PUBLIC_URL + "/New-Generate-invoice",
  InternalComplaints: process.env.PUBLIC_URL + "/internalComplaint",
  ComplaintRegisters: process.env.PUBLIC_URL + "/complaint-register",
  ComplaintMain: process.env.PUBLIC_URL + "/complaint-main",
  ComplaintActionMain: process.env.PUBLIC_URL + "/complaint-actions-main",
  oilProduction: process.env.PUBLIC_URL + "/oilproduction",
  desiriUsers: process.env.PUBLIC_URL + "/DesiriUser",
  desiriBulls: process.env.PUBLIC_URL + "/DesiriBulls",
  desiriGaana: process.env.PUBLIC_URL + "/DesiriGaana",
  desiriRoles: process.env.PUBLIC_URL + "/DesiriRoles",
  RoleAssignment: process.env.PUBLIC_URL + "/RoleAssignment",
  CreatingRole: process.env.PUBLIC_URL + "/CreatingRole",
  oilProductiondatatable: process.env.PUBLIC_URL + "/oildatatable",
  RawMaterialsPurchasedatatable: process.env.PUBLIC_URL + "/RawMaterialdatatable",
  CustomerComplaintMain: process.env.PUBLIC_URL + "/CustomerComplaintMain",
  CustomerServComplaintRegister: process.env.PUBLIC_URL + "/service-complaint-register",
  posTargetMapping: process.env.PUBLIC_URL + "/POS_TargetMapping",
  posReportDetails: process.env.PUBLIC_URL + "/POS_ReportDetail",
  FeatureAccessAssign: process.env.PUBLIC_URL + "FeatureAccesAssign",
  mySubscriptions: process.env.PUBLIC_URL + "/my-subscriptions",
  posInventoryReport: process.env.PUBLIC_URL + "POS-Inventory-Report",
  DeliveryCashMain: process.env.PUBLIC_URL + "/delivery-cash-main",
  TestReports: process.env.PUBLIC_URL + "/TesReports",
  TestReporttest: process.env.PUBLIC_URL + "/TesReporttest",
  deliveryAnalysis: process.env.PUBLIC_URL + "/Delivery-Analysis",
  oilProduction1: process.env.PUBLIC_URL + "/oilproduction1",
  oilProductiondatatable1: process.env.PUBLIC_URL + "/oildatatable1",
  oilProductiondatatable2: process.env.PUBLIC_URL + "/oildatatable2",
  ViewRawMaterials: process.env.PUBLIC_URL + "/ViewALLRawMaterials",
  storeCashMain: process.env.PUBLIC_URL + "/store-cash-main",
  CustomerExecutiveSalesReport: process.env.PUBLIC_URL + "/CustomerExecutiveSalesReport",
  InvoicedBySalesReport: process.env.PUBLIC_URL + "/InvoicedBySalesReport",
  RawMaterialCategories: process.env.PUBLIC_URL + "/View-RawMaterialCategory",
  InternalComplaintRegister: process.env.PUBLIC_URL + "/internalComplaintRegister",
  InternalComplaintMain: process.env.PUBLIC_URL + "/internal-complaint-main",
  InternalComplaintActionMain: process.env.PUBLIC_URL + "/internal-complaint-actions-main",
  OilProductionSummaryReport: process.env.PUBLIC_URL + "/Monthly-Summary-Report",
  CashReportMain: process.env.PUBLIC_URL + "/cash-report-main",
  CustomerExecutiveTargetMapping: process.env.PUBLIC_URL + "/CustomerExecutive-TargetMapping",
  AccountsCashMain: process.env.PUBLIC_URL + "/accounts-cash-main",
  outwardChallan: process.env.PUBLIC_URL + "/Outward-Challan",
  PerformanceReportforCE: process.env.PUBLIC_URL + "/PerformanceReport",
  CEDailyActivityReportModule: process.env.PUBLIC_URL + "/CEDailyActivityReportModule",
  rawmaterialInventory: process.env.PUBLIC_URL + "/raw-material-inventory",
  rawmaterialMovementLog: process.env.PUBLIC_URL + "/raw-material-movement-log",
  OrderDeliverySummary: process.env.PUBLIC_URL + "/OrderDeliverySummary",
  ViewAllChallan: process.env.PUBLIC_URL + "/View-All-Challan",
  DeliveryExecutivePerformance: process.env.PUBLIC_URL + "/DeliveryExecutivePerformance",
  RawMaterailsReport: process.env.PUBLIC_URL + "/RawMaterailsReport",
  RawMaterialHistory: process.env.PUBLIC_URL + "/RawMaterialHistory",
  AddVehicle: process.env.PUBLIC_URL + "/Add-Vehicle",
  ProductBatchSummary: process.env.PUBLIC_URL + "/Product-Batch-Summary",
  posPProductStockSummary: process.env.PUBLIC_URL + "/POS-Product-Stock-Summary",
  BullStatistics: process.env.PUBLIC_URL + "/BullStatistics",
  Traceability: process.env.PUBLIC_URL + "/traceability",
  allUserAddress: process.env.PUBLIC_URL + "/user-addresses",
  newsManagement: process.env.PUBLIC_URL + "/news-management",
  addNews: process.env.PUBLIC_URL + "/add-news",
  RawMaterialOutwardChallan: process.env.PUBLIC_URL + "/Raw-Material-Outward-Challan",
  myRewards: process.env.PUBLIC_URL + "/my-rewards",
  productRewardRates: process.env.PUBLIC_URL + "/product-reward-rates",
  newcomplaintsummary: process.env.PUBLIC_URL + "/New-Complaint-Summary",
  mycomplaints: process.env.PUBLIC_URL + "/My-Complaints",
  CustomerserviceComplaintRegister: process.env.PUBLIC_URL + "/Customer-Service-Complaint-Register",
  UserSwipeMachineAccess: process.env.PUBLIC_URL + "/User-Swipe-Machine-Access",
  courierDetails: process.env.PUBLIC_URL + "/courier-details",
  customerAnalytics: process.env.PUBLIC_URL + "/customer-analytics",
  WipProductionMain: process.env.PUBLIC_URL + "/work-inprogress-dashboard-main",
  StockSummaryDashboard: process.env.PUBLIC_URL + "/oil-stock-summary",
  whyNotDeliveredSummary: process.env.PUBLIC_URL + "/why-not-delivered-summary",
  salesProductionReport: process.env.PUBLIC_URL + "/sales-production-report",
  OrderInvoiceTimelineReport: process.env.PUBLIC_URL + "/order-invoice-report",
  UserSalesOrdering: process.env.PUBLIC_URL + "/user-sales-ordering",
  userTrafficAudit: process.env.PUBLIC_URL + "/user-traffic-audit",

};

export default RouteConstant;
